export default "__VITE_ASSET__DDITynOr__"